import React, { FC } from "react";
import { Button, message, Input } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { Description } from "@/components/YhBox/Description";
import { useDictModel } from "@/views/base/dict/dictModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { globalPrompt } from "@/components/message";
import { useWorkshopQueryModel } from "@/views/workshop/workshopQuery/workshopQueryModel";

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailAddForm,
        detailEditForm,
        detailLookForm,
        topButsControl,
        setSettleVisible,
        onExamine,
        onApproved,
        getDetailEditOne,
        onBackExamine,
        onBackApproved
    } = useMaintenanceDetailsModel();
    const { getTreeNodeName } = useDictModel();
    const { finished } = useWorkshopQueryModel();
    const onSettle = () => {
        if (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final" || detailEditForm.status === "maintenance-status.paying" || mode === "look") {
            setSettleVisible(true)
        } else {
            message.error("您的工单还没有完工，无法进行结算")
        }

    }
    const Examine = async () => {
        let auditReason: string = ""
        globalPrompt("modal", {
            title: "维修单审核",
            type: "success",
            text: <><span>请输入审核原因</span>
                <Input onChange={(e) => { auditReason = e.target.value }} /></>,
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                    auditReason
                }
                let retData = await onExamine(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const Approved = async () => {
        let auditReason: string = ""
        globalPrompt("modal", {
            title: "维修单审核完成",
            type: "success",
            text: <><span>请输入审核完成原因</span>
                <Input onChange={(e) => { auditReason = e.target.value }} /></>,
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                    auditReason
                }
                let retData = await onApproved(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const Finished = () => {
        globalPrompt("modal", {
            title: "工单完工",
            type: "success",
            text: "",
            okText: "确定",
            onOk: () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                }
                finished(obj).then(res => {
                    globalPrompt("message", { text: "工单完工", type: "success" });
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    //退单待审
    const backExamine = () => {
        globalPrompt("modal", {
            title: "维修退单审核",
            type: "success",
            text: '',
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                }
                // console.log(obj)
                let retData = await onBackExamine(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    //退单审核通过
    const backApproved = () => {
        globalPrompt("modal", {
            title: "维修退单审核完成",
            type: "success",
            text: "",
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                }
                let retData = await onBackApproved(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const action = mode === "edit" ? <>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_AUDIT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={Examine}
                disabled={topButsControl || !(detailEditForm.status === "maintenance.completed")}
            >完工审核</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_AUDIT_IN}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={Approved}
                disabled={topButsControl || !(detailEditForm.status === "maintenance.under-review")}
            >完工审核通过</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_AUDIT_IN}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={Finished}
                disabled={topButsControl || !(detailEditForm.status === "maintenance.approved")}
            >完工</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_BILL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onSettle}
                disabled={topButsControl || !(detailEditForm.status === "maintenance-status.final" || detailEditForm.status === "maintenance-status.paying")}
            >确认结算</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CHANGEBACK_EXAMINE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={backExamine}
                disabled={topButsControl || !!!(detailEditForm.status === "maintenance.settle" && detailEditForm.returnType === null)}
            // disabled={true}
            >退单审核</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CHANGEBACK_APPROVED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={backApproved}
                disabled={topButsControl || !!!(detailEditForm.status === "maintenance.settle" && detailEditForm.returnType === "maintenance.chargeback.pend")}
            // disabled={true}
            >退单审核通过</Button>
        </YhAuth>
    </> : mode === "look" ? <>
        <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_BILL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                // disabled={topButsControl}
                onClick={onSettle}
            >结算查看</Button>
        </YhAuth>
    </> : <></>;
    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }
    const orderStatu: IDescription[] = [
        {
            label: "维修单",
            value: typeTitle[mode].maintenanceCode ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: (typeTitle[mode]?.status && getTreeNodeName(typeTitle[mode]?.status as string)) ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "退单状态",
            value: (typeTitle[mode]?.returnType && getTreeNodeName(typeTitle[mode]?.returnType as string)) ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            hidden={mode !== "add" ? false : true}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}